import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RootLayout } from '../components/layout/RootLayout';
import { LoadingScreen } from '../components/common/LoadingScreen';
import { ProductPageLayout } from '../components/solutions/ProductPageLayout';
import { getSolution } from '../data/solutions';

// Lazy-loaded pages for optimal performance and code-splitting
const Home = lazy(() => import('../Pages/Home'));
const Services = lazy(() => import('../Pages/Services'));
const About = lazy(() => import('../Pages/About'));
const Projects = lazy(() => import('../Pages/Projects'));
const Contacts = lazy(() => import('../Pages/Contacts'));
const Solutions = lazy(() => import('../Pages/Solutions'));
const NotFound = lazy(() => import('../Pages/NotFound'));

export const AppRoutes: React.FC = () => {
  const solutionPage = (slug: string) => {
    const solution = getSolution(slug);
    return solution ? <ProductPageLayout solution={solution} /> : null;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootLayout />}>
          {/* Home Route */}
          <Route
            index
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Home />
              </Suspense>
            }
          />

          {/* Services Routes (with Portuguese and legacy alias) */}
          <Route
            path="servicos"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Services />
              </Suspense>
            }
          />
          <Route
            path="services"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Services />
              </Suspense>
            }
          />

          {/* About Routes (with Portuguese and legacy alias) */}
          <Route
            path="sobre"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <About />
              </Suspense>
            }
          />
          <Route
            path="about-us"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <About />
              </Suspense>
            }
          />

          {/* Projects Routes */}
          <Route
            path="projectos"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Projects />
              </Suspense>
            }
          />
          <Route
            path="projects"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Projects />
              </Suspense>
            }
          />

          {/* Contacts Routes */}
          <Route
            path="contactos"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Contacts />
              </Suspense>
            }
          />
          <Route
            path="contacts"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Contacts />
              </Suspense>
            }
          />
          <Route
            path="contact-us"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Contacts />
              </Suspense>
            }
          />

          <Route
            path="solucoes"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <Solutions />
              </Suspense>
            }
          />
          {['nova-erp', 'nova-rh', 'hiperpay', 'hiperhost', 'smsgo', 'nzila-pro', 'hiperbot-ia', 'hiper-ativo'].map((slug) => (
            <Route key={slug} path={`solucoes/${slug}`} element={solutionPage(slug)} />
          ))}

          {/* 404 Catch-All Route */}
          <Route
            path="*"
            element={
              <Suspense fallback={<LoadingScreen />}>
                <NotFound />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
